module.exports = __webpack_public_path__ + "static/media/duplex_blue.72faab0d.svg";